/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ScenarioExecutionLog { 
    id?: string;
    instanceId?: string;
    stepId?: string;
    timestamp?: Date;
    status?: ScenarioExecutionLog.StatusEnum;
    message?: string;
    context?: { [key: string]: any; };
}
export namespace ScenarioExecutionLog {
    export type StatusEnum = 'SUCCESS' | 'FAILED' | 'STARTED' | 'PAUSED' | 'STOPPED';
    export const StatusEnum = {
        SUCCESS: 'SUCCESS' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum,
        STARTED: 'STARTED' as StatusEnum,
        PAUSED: 'PAUSED' as StatusEnum,
        STOPPED: 'STOPPED' as StatusEnum
    };
}